import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false,
})
export class UnauthorizedComponent {
  @Input() transparentBackground: boolean = false;

  constructor(private readonly router: Router) {}

  goHome() {
    this.router.navigateByUrl('/home');
  }

  contactAdmin() {
    this.router.navigateByUrl('/about');
  }
}
